<template>
    <SmallModal
        :show="show"
        :z-index-class="zIndexClass"
        @close="$emit('close')"
    >
        <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Add new client
                </h3>
            </div>
        </div>
        <div class="my-8 w-full flex flex-col space-y-4">
            <div>
                <label
                    for="name"
                    class="block text-sm font-medium text-gray-700"
                >Client Name</label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        ref="clientName"
                        id="name"
                        v-model="form.name"
                        type="text"
                        name="name"
                        class="block w-full pr-10 sm:text-sm rounded-md"
                        :class="{'focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300': form.errors.name, 'focus:ring-indigo-200 focus:border-indigo-300 border-gray-300': !form.errors.name}"
                        placeholder="Client, Inc"
                        aria-invalid="true"
                        aria-describedby="name-error"
                        v-focus
                    >
                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <!-- Heroicon name: solid/exclamation-circle -->
                        <svg
                            v-if="form.errors.name"
                            class="h-5 w-5 text-red-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </div>
                </div>
                <p
                    v-if="form.errors.name"
                    id="email-error"
                    class="mt-2 text-sm text-red-600"
                >
                    {{ form.errors.name }}
                </p>
            </div>
            <div>
                <label
                    for="name"
                    class="block text-sm font-medium text-gray-700"
                >Key Account Manager</label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <select
                        id="kam"
                        v-model="form.key_account_manager"
                        class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md focus:ring-indigo-200 focus:border-indigo-300 border-gray-300"
                    >
                        <option
                            v-for="option in team_members"
                            :value="option.value"
                        >
                            {{ option.text }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                @click="save"
            >
                Add
            </button>
            <button
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                @click="$emit('close')"
            >
                Cancel
            </button>
        </div>
    </SmallModal>
</template>

<script setup>
import {ref, onMounted, watch} from "vue";
import SmallModal from './SmallModal.vue'
import { usePage } from '@inertiajs/vue3'
const emit = defineEmits(['created', 'close'])

const form = ref({
    name: '',
    key_account_manager: null,
    errors: {}
})

const props = defineProps({
    query: {
        type: String,
        default: ''
    },
    show: {
        type: Boolean,
        default: false
    },
    zIndexClass: {
      type: String,
      required: false,
      default: 'z-50',
    }
})

const team_members = ref([]);
const clientName = ref(null)

const vFocus = {
    mounted: (el) => el.focus()
}

onMounted(() => {
    team_members.value.push({ value: usePage().props.team.owner.id, text: usePage().props.team.owner.name });
    for (let i = 0; i < usePage().props.team.users.length; i++) {
        team_members.value.push({ value: usePage().props.team.users[i].id, text: usePage().props.team.users[i].name });
    }
    form.value.name = props.query
    form.value.key_account_manager = usePage().props.user.id
})

watch(() => props.show, (newValue) => {
    if (newValue) {
        form.value.name = props.query
    }
    setTimeout(() => {
        clientName.value.focus()
    }, 50)
});

function save() {
    axios.post(route('api.clients.store'), {
        name: form.value.name,
        key_account_manager: form.value.key_account_manager
    }).then(response => {
        emit('created', response.data)
        emit('close')
        form.value.name = ''
        form.value.key_account_manager = usePage().props.user.id
        form.value.errors = {}
    }).catch(error => {
        if( typeof error.data === 'undefined') console.log(error)
        else form.value.errors = error.data.errors
    })
}
</script>
